import { EscalationData } from "../../models/dtos";

export class SolMaterialEscalationDialogDataModel {
    escalationData: EscalationData;
    escalationType: string;
    sectionLabel: string;
    applyMaterialEscalationToAll?: boolean;
    applyLaborEscalationToAll?: boolean;
    isEscalationDisabled?: boolean;
}